import * as React from 'react';
import uniqBy from 'lodash/uniqBy';
import { useCurrentRefinements, useRange } from 'react-instantsearch';
import { Price } from '@grandvisionhq/common';
import { Tag } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { isNumber } from '@grandvisionhq/utils';
import { useAlgoliaConfig } from '../../AlgoliaConfig.js';
import { getFacetOptionLabel } from '../../utils/get-facet-option-label.js';
import ClearRefinements from '../ClearRefinements/ClearRefinements.js';

const CurrentRefinements = ()=>{
    const { items: items1 , refine  } = useCurrentRefinements();
    const { facets  } = useAlgoliaConfig();
    const intl = useIntl();
    const uniqItems = React.useMemo(()=>uniqBy(items1, (item)=>item.attribute + item.label
        )
    , [
        items1
    ]);
    const refinementItems = React.useMemo(()=>{
        return uniqItems.reduce((result, item)=>{
            const facet = facets.find(({ attribute  })=>attribute === item.attribute
            );
            if (!facet || facet.hidden) {
                return result;
            }
            const element = /*#__PURE__*/ React.createElement(React.Fragment, {
                key: facet.attribute
            }, isRangeRefinement(item) ? /*#__PURE__*/ React.createElement(RangeRefinement, {
                item: item
            }) : item.refinements ? renderItems(item.refinements, facet) : null);
            return [
                ...result,
                element
            ];
        }, []);
    }, [
        uniqItems
    ]);
    return refinementItems.length > 0 ? /*#__PURE__*/ React.createElement("div", {
        className: "current-refinements",
        "data-t": "current-refinements"
    }, refinementItems, /*#__PURE__*/ React.createElement(ClearRefinements, null)) : null;
    function renderItems(items, facet) {
        return /*#__PURE__*/ React.createElement(React.Fragment, null, items.map((item)=>/*#__PURE__*/ React.createElement("span", {
                key: item.label,
                className: "current-refinements__tag"
            }, /*#__PURE__*/ React.createElement(Tag, {
                onClick: ()=>refine(item)
            }, facet.showLabel && facet.labelKey && intl.hasLabel(facet.labelKey) && /*#__PURE__*/ React.createElement("span", {
                className: "current-refinements__label"
            }, intl.getLabel(facet.labelKey || facet.id), ":", ' '), getFacetOptionLabel(facet, item.label, intl).label))
        ));
    }
};
function RangeRefinement({ item  }) {
    const intl = useIntl();
    const { range: { max , min  } , start , refine: rangeRefine ,  } = useRange({
        attribute: item.attribute
    });
    if (!isNumber(min) || !isNumber(max) || max === min) {
        return null;
    }
    const currentRefinement = {
        min: Math.max(min, Number.isFinite(start[0]) ? start[0] : min),
        max: Math.min(max, Number.isFinite(start[1]) ? start[1] : max)
    };
    return /*#__PURE__*/ React.createElement("span", {
        className: "current-refinements__tag"
    }, /*#__PURE__*/ React.createElement(Tag, {
        onClick: ()=>rangeRefine([
                min,
                max
            ])
    }, /*#__PURE__*/ React.createElement(Price, {
        value: Math.round(currentRefinement.min / 100),
        currency: intl.currency,
        centAmount: false
    }), ' – ', /*#__PURE__*/ React.createElement(Price, {
        value: Math.round(currentRefinement.max / 100),
        currency: intl.currency,
        centAmount: false
    })));
}
function isRangeRefinement(refinement) {
    return refinement.refinements.some((item)=>item.type === 'numeric'
    );
}

export { CurrentRefinements };
//# sourceMappingURL=CurrentRefinements.js.map
